export default "__VITE_ASSET__DRF_M1Ns__"